// Role tier color mapping. Synced with backend ROLE_TIER.
export const TIER_THEMES = {
  labor:     { color: "#4A4E51", rgb: "74, 78, 81",   label: "Labor & Logistics" },
  direction: { color: "#D9383A", rgb: "217, 56, 58",  label: "Direction & Continuity" },
  creative:  { color: "#6B4EFF", rgb: "107, 78, 255", label: "Creative, Talent & HOD" },
  stage:     { color: "#EC4899", rgb: "236, 72, 153", label: "Stage & Performance" },
};

export const TIER_DESCRIPTION = {
  labor:     "Oversized controls. High contrast. Minimal nested menus.",
  direction: "High data density. Rapid list views. Schedule assembly.",
  creative:  "Sleek aesthetic. Media-heavy cards. Strict security blocks.",
  stage:     "Disco-light iCard. Movement-first UI. Built for dancers and choreographers.",
};

export function applyTierTheme(tier) {
  const t = TIER_THEMES[tier] || TIER_THEMES.direction;
  const root = document.documentElement;
  root.style.setProperty("--association-theme", t.color);
  root.style.setProperty("--association-theme-rgb", t.rgb);
  root.style.setProperty("--association-theme-soft", `rgba(${t.rgb}, 0.14)`);
}
